/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e){super(r,"sampler2D",1,(s,o,t)=>s.bindTexture(r,e(o,t)))}}export{e as Texture2DPassUniform};
